/** Parse YYYY-MM-DD → calendar year/month (local date string, not timezone-shifted). */
export function parseYearMonthFromDateYyyyMmDd(date: string): {
  year: number;
  month: number;
} {
  const m = /^(\d{4})-(\d{2})-\d{2}$/.exec(date.trim());
  if (!m) {
    throw new Error("Invalid date (expected YYYY-MM-DD)");
  }
  const year = Number(m[1]);
  const month = Number(m[2]);
  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    month < 1 ||
    month > 12
  ) {
    throw new Error("Invalid date (expected YYYY-MM-DD)");
  }
  return { year, month };
}
